export default function getEntityFromRedux(state, entityType, entityId) {
  if (!state.bees.entities[entityType]) return null;
  const reduxEntity = state.bees.entities[entityType][entityId];
  return reduxEntity;
}
